import React from "react";
import { BrowserRouter, Route, Routes as RouterRoutes, Navigate } from 'react-router-dom'
import MainLayout from './layout/MainLayout/MainLayout'
import Login from './layout/Login/Login'
import ListadoUsuarios from './layout/Login/ListadoUsuarios'
import Logout from './layout/Login/Logout'
import AuthContextProvider from "./contexts/AuthContext.js";

// Logs
import Logs from './views/Logs/ListadoLogs'

// Whatsapp
import Whatsapp from "./views/WhatsApp/Whatsapp";

// Admin Panel
import AdminPanel from './views/Admin/AdminPanel';

// Retiros
import BotonesRetiros from "./views/Retiros/BotonesRetiros.jsx";
import ListadoSocios from "./views/Retiros/Socios/ListadoSocios.jsx";
import ListadoRetiros from "./views/Retiros/Retiros/ListadoRetiros.jsx";
import RetirosCreate from "./views/Retiros/Retiros/RetirosCreate.jsx";
import ListadoPorRetirar from "./views/Retiros/PorRetirar/ListadoPorRetirar.jsx";
import PorRetirarCreate from "./views/Retiros/PorRetirar/PorRetirarCreate.jsx";

// Cargos
import ListadoCargos from "./views/Cargos/ListadoCargos"
import CargosCreate from "./views/Cargos/CargosCreate"

// Abonos
import ListadoAbonos from "./views/Abonos/ListadoAbonos"
import AbonosCreate from "./views/Abonos/AbonosCreate"

// Estado Cuenta
import EstadoCuenta from "./views/EstadoCuenta/EstadoCuenta";

// Gastos
import BotonesGastos from "./views/Gastos/BotonesGastos"
import ListadoGastosGeneral from './views/Gastos/GastosGeneral/ListadoGastosGeneral'
import GastosGeneralCreate from './views/Gastos/GastosGeneral/GastosGeneralCreate'
import ListadoConceptosGastos from './views/Gastos/ConceptosGastos/ListadoConceptosGastos'
import ConceptosGastosCreate from './views/Gastos/ConceptosGastos/ConceptosGastosCreate'

// Dashboard Principal
import OverviewDashboard from './views/Dashboard/OverviewDashboard';

// Grid Dashboard
import GridDashboard from './views/GridDashboard/GridDashboard';

// Futures Bot
import FuturesDashboard from './views/Futures/FuturesDashboard';
import FuturesConfig from './views/Futures/FuturesConfig';

// Sniper Dashboard (Solana)
import SniperDashboard from './views/Sniper/SniperDashboard';
import SniperConfig from './views/Sniper/SniperConfig';

// Wallets
import WalletsOverview from './views/Wallets/WalletsOverview';

// Account Statement
import AccountStatement from './views/AccountStatement/AccountStatement';

function Routes() {
    return (
        <AuthContextProvider>
            <BrowserRouter>
                <RouterRoutes>
                    {/* Rutas públicas sin MainLayout */}
                    <Route path="/Login" element={<Login />} />
                    <Route path="/Logout" element={<Logout />} />
                    
                    {/* Rutas protegidas con MainLayout */}
                    <Route path="/*" element={
                        <MainLayout>
                            <RouterRoutes>
                                {/* Redirect root to wallets */}
                                <Route path="/" element={<Navigate to="/wallets" replace />} />
                                
                                {/* Dashboard Principal */}
                                <Route path="/dashboard" element={<OverviewDashboard />} />
                                
                                {/* Wallets */}
                                <Route path="/wallets" element={<WalletsOverview />} />
                                
                                {/* Grid Trading Dashboard */}
                                <Route path="/grid" element={<GridDashboard />} />
                                
                                {/* Sniper Bot Dashboard (Solana) */}
                                <Route path="/sniper" element={<SniperDashboard />} />
                                <Route path="/sniper/config" element={<SniperConfig />} />
                                
                                {/* Futures Bot */}
                                <Route path="/futures" element={<FuturesDashboard />} />
                                <Route path="/futures/config" element={<FuturesConfig />} />
                                
                                {/* Account Statement */}
                                <Route path="/account" element={<AccountStatement />} />
                                
                                {/* Users Management */}
                                <Route path="/ListadoUsuarios" element={<ListadoUsuarios />} />
                                
                                {/* Admin Panel */}
                                <Route path="/admin" element={<AdminPanel />} />
                                
                                {/* Logs */}
                                <Route path="/MenuLogs" element={<Logs />} />
                                
                                {/* Whatsapp */}
                                <Route path="/Whatsapp" element={<Whatsapp />} />
                                
                                {/* Retiros */}
                                <Route path="/MenuRetiros" element={<BotonesRetiros />} />
                                <Route path="/Socios" element={<ListadoSocios />} />
                                <Route path="/Retiros" element={<ListadoRetiros />} />
                                <Route path="/RetirosCreate" element={<RetirosCreate />} />
                                <Route path="/PorRetirar" element={<ListadoPorRetirar />} />
                                <Route path="/PorRetirarCreate" element={<PorRetirarCreate />} />
                                
                                {/* Cargos */}
                                <Route path="/ListadoCargos" element={<ListadoCargos />} />
                                <Route path="/CargosCreate" element={<CargosCreate />} />
                                
                                {/* Abonos */}
                                <Route path="/ListadoAbonos" element={<ListadoAbonos />} />
                                <Route path="/AbonosCreate" element={<AbonosCreate />} />
                                
                                {/* Estado Cuenta */}
                                <Route path="/EstadoCuenta" element={<EstadoCuenta />} />
                                
                                {/* Gastos */}
                                <Route path="/MenuGastos" element={<BotonesGastos />} />
                                <Route path="/Gastos" element={<ListadoGastosGeneral />} />
                                <Route path="/GastosCreate" element={<GastosGeneralCreate />} />
                                <Route path="/ConceptosGastos" element={<ListadoConceptosGastos />} />
                                <Route path="/conceptosGastosCreate" element={<ConceptosGastosCreate />} />
                            </RouterRoutes>
                        </MainLayout>
                    } />
                </RouterRoutes>
            </BrowserRouter>
        </AuthContextProvider>
    )
}

export default Routes
